// src/socket/index.js
import { io } from 'socket.io-client';
import { SOCKET_URL } from '../network/endpoints';
import authConfig from '../configs/auth';

const socket = io(SOCKET_URL, {
    autoConnect: false, // Prevents automatic connection
    transports: ['websocket'], // Ensures WebSocket is used
    query: {}, // Will be populated with userId when connecting
    auth: (cb) => cb({ token: window.localStorage.getItem(authConfig.storageTokenKeyName) }),
});

export default socket;
